import {HistoryStep} from "./historyStep";
import {HistoryController, IHistoryStepWithSelObs} from "./historyController";
import {EventVerteiler} from "../../global/eventVerteiler";
import {SELOBEVENTNAMES} from "../../global/GlobalEventnames";
import {CONSTANTS} from "../meta_data";

export class HistoryStepZOrderOperation extends HistoryStep implements IHistoryStepWithSelObs {
    private id;
    private readonly oldIndex;
    private readonly newIndex;

    constructor(historyController: HistoryController, parameters) {
        super(historyController, parameters);
        if (typeof (this.type) !== "string") {
            parameters.type = "selObZOrder";
        }
        this.id = parameters.id;
        this.oldIndex = parameters.oldIndex;
        this.newIndex = parameters.newIndex;
    }

    undo = () => this.setZorder(this.oldIndex);
    redo = () => this.setZorder(this.newIndex);

    private setZorder(zOrder) {
        const $this = this;
        this.controller.restoreCameraAndModelSettings(this.viewDetails);
        this.busy();
        setTimeout(
            function () {
                EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, $this.id);
                $this.controller.selObController.changeZOrder($this.id, zOrder, "historyController");
                $this.noLongerBusy();
            },
            CONSTANTS.UNDO_DELAY
        );
    }

    replaceId(origId, newId) {
        if (this.id === origId) {
            this.id = newId;
        }
    }
}